import { type api } from 'common';

export function getDefaultDocumentSearchConfig(): api.FlowDefinition.DocumentSearchBlockConfig {
  return {
    searchQuery: '',
  };
}
